import { render } from "./HeaderHeroEditModal.vue?vue&type=template&id=2ebdd7d8&scoped=true"
import script from "./HeaderHeroEditModal.vue?vue&type=script&lang=js"
export * from "./HeaderHeroEditModal.vue?vue&type=script&lang=js"

import "./HeaderHeroEditModal.vue?vue&type=style&index=0&id=2ebdd7d8&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebdd7d8"]])

export default __exports__